let postfixs = ['Left', 'Top', 'Width', 'Height'];

/**
 * <b>dom을 조작하는 메소드들의 모아놓은 객체이며 싱글턴입니다.</b>
 * <pre>
 * dom과 관련된 메소드들은 여기에 정의 됩니다.
 * 만약 여기 없다면 여기에 추가시켜주면됩니다.
 * </pre>
 */
class Dom {
    /**
     * <b>postfix에 해당하는 offset을 반환합니다. 절대값으로 반환됩니다.</b>
     * @param {String} postfix 
     * @param {dom} dom 
     */
    getOffset(postfix, dom) {
        if (dom) {
            let sum = dom[`offset${postfix}`];
            return sum + this.getOffset(postfix, dom.offsetParent);
        } else {
            return 0;
        }
    }

    //TODO 레거시인데 앞으로 쓸 가능성이 쥐꼬리만큼 있음
    getClient(postfix,dom){
        if(dom){
            let sum = dom[`scroll${postfix}`];
            return sum += this.getOffset(postfix,dom.offsetParent);
        }else{
            return 0;
        }
    }

    /**
     * <b>postfix에 해당하는 offset을 반환합니다. getOffset의 진입점으로 둘의 역활은 동일합니다.</b>
     * @param {String} postfix 
     * @param {dom} dom 
     */
    getOffsetFirst(postfix, dom) {
        if (this.checkValidPostfix(postfix)) {
            return this.getOffset(postfix, dom);
        } else {
            return 0;
        }
    }

    /**
     * <b>절대 x좌표를 반환합니다.</b>
     * @param {dom} dom 
     */
    getOffsetLeft(dom) {
        return this.getOffsetFirst('Left', dom);
    }

     /**
     * <b>절대 y좌표를 반환합니다.</b>
     * @param {dom} dom 
     */
    getOffsetTop(dom) {
        return this.getOffsetFirst('Top', dom);
    }

    /**
     * <b>절대 너비를 반환하는데 잘 안쓰입니다. 솔직히 왜 만들었는지 모르겠습니다.</b>
     * @param {dom} dom 
     */
    getOffsetWidth(dom) {
        return this.getOffsetFirst('Width', dom);
    }

    /**
     * <b>절대 높이를 반환하는데 잘 안쓰입니다. 솔직히 왜 만들었는지 모르겠습니다.</b>
     * @param {dom} dom 
     */
    getOffsetHeight(dom) {
        return this.getOffsetFirst('Height', dom);
    }

    /**
     * <b>해당 접미사가 항상 옳은 값이 들어온다는 보장은 없습니다. 이를 체크합니다.</b>
     * @param {String} postfix 
     */
    checkValidPostfix(postfix) {
        let result = false;
        postfixs.forEach((value) => {
            result = value == postfix ? true : result
        });
        return result;
    }
}

export default new Dom();